'use client';

import { FC } from 'react';
import classNames from 'classnames';
import {
    useContentfulInspectorMode,
    useContentfulLiveUpdates,
} from '@contentful/live-preview/react';

import { GothamBook } from '@/utils/fonts';
import { TypeHeroComponentWithoutUnresolvableLinksResponse } from '../_generated';
import MainBodyToReact from './MainBodyToReact';

interface PageTitleProps {
    className?: string;
    heroComponent?: TypeHeroComponentWithoutUnresolvableLinksResponse;
    hidePreview?: boolean;
}

const PageTitle: FC<PageTitleProps> = ({ className, heroComponent, hidePreview = false }) => {
    const heroComponentLiveLayout = useContentfulLiveUpdates(heroComponent);
    const inspectorProps = useContentfulInspectorMode({ entryId: heroComponentLiveLayout?.sys.id });

    return (
        <section className={classNames('tw-flex tw-flex-col tw-items-center', className)}>
            <h1
                className="tw-text-[36px] tw-text-[#003865] tw-mim-h-[73px] tw-mb-[23px] tw-font-bold tw-text-center"
                {...(hidePreview
                    ? {}
                    : inspectorProps({
                          fieldId: 'heroImageTitle',
                      }))}
            >
                {heroComponentLiveLayout?.fields?.heroImageTitle}
            </h1>
            {heroComponentLiveLayout?.fields?.heroImageRichSubTitle ? (
                <div
                    className="tw-max-w-[700px] tw-text-center mt-2"
                    {...(hidePreview
                        ? {}
                        : inspectorProps({
                              fieldId: 'heroImageRichSubTitle',
                          }))}
                >
                    <MainBodyToReact
                        body={heroComponentLiveLayout?.fields?.heroImageRichSubTitle}
                        classes={{
                            p: 'tw-text-[16px] tw-text-[#4b4f54] tw-font-gotham tw-font-normal !tw-pb-0',
                        }}
                    />
                </div>
            ) : null}
        </section>
    );
};

export default PageTitle;
